import "../css/style.scss";

export default function NotFound() {
  return (
    <section>
      <div className="not-found">
        <h1>404</h1>
        <h2>Oops, Page Not Found</h2>
        <p>¯\_(ツ)_/¯</p>
        <div class="btn" onClick={() => window.open("/", "_self")}>
          Go Back
        </div>
      </div>
    </section>
  );
}
